import { i18n } from '@shared/i18n';
import IdField from '@shared/fields/id-field';
import DateTimeRangeField from '@shared/fields/date-time-range-field';
import DateTimeField from '@shared/fields/date-time-field';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import DecimalField from '@shared/fields/decimal-field';
import EnumeratorField from '@shared/fields/enumerator-field';

function label(name) {
  return i18n(`entities.location.fields.${name}`);
}

function enumeratorLabel(name, value, entity = 'location') {
  return i18n(`entities.${entity}.enumerators.${name}.${value}`);
}

const fields = {
  id: new IdField('id', label('id')),
  name: new StringField('name', label('name'), {
    "required": true
  }),
  latitude: new DecimalField('latitude', label('location'), {
    "required": true
  }),
  longitude: new DecimalField('longitude', label('location'), {
    "required": true
  }),
  information: new StringField('information', label('information'), {}),
  createdAt: new DateTimeField(
    'createdAt',
    label('createdAt'),
  ),
  access: new EnumeratorField('access', label('access'), [
    { id: 'public', label: enumeratorLabel('access', 'public') },
    { id: 'private', label: enumeratorLabel('access', 'private') },
  ], { "required": true }),
  updatedAt: new DateTimeField(
    'updatedAt',
    label('updatedAt'),
  ),
  createdAtRange: new DateTimeRangeField(
    'createdAtRange',
    label('createdAtRange'),
  ),

};

export class LocationModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
